import { createSelector } from '@reduxjs/toolkit';

const selectAuthData = (entities) => entities.authorization;

export const selectSubjectId = createSelector([selectAuthData], (authData) => authData.subjectId);
